import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'
import { catchError, EMPTY, map, Observable, tap, throwError } from 'rxjs'
import { Store } from '@ngrx/store'
import { DatasetBrowserApiService } from '../services/dataset-browser-api.service'
import { userActions } from '../../state/user/user.actions'
import { casesActions } from '../../state/cases/cases.actions'
import { ToasterService } from '../services/toaster.service'

@Injectable({
    providedIn: 'root',
})
export class CasesResolver implements Resolve<boolean> {
    constructor(
        private readonly datasetBrowserApi: DatasetBrowserApiService,
        private readonly store: Store,
        private readonly toaster: ToasterService
    ) {}

    resolve(): Observable<boolean> {
        return this.datasetBrowserApi.getFolders().pipe(
            tap(cases => this.store.dispatch(casesActions.casesLoaded({ cases }))),
            map(() => true),
            catchError(err => {
                if (err?.status === 401) {
                    this.store.dispatch(userActions.startLogout())
                    return EMPTY
                } else {
                    this.toaster.httpError(err, 'Error loading datasets.')
                    return throwError(() => err)
                }
            })
        )
    }
}
